// @flow

import * as React from 'react';
import glamorous from 'glamorous';
import { connect } from 'react-redux';
import { padding } from 'polished';
import Button from 'app/components/commons/Button';
import appLinksSelector from '../../selectors/appLinksSelector';
import AppLink from '../commons/AppLink';

type Props = {
  appLinks: Array<Object>,
  children: any,
  playLink: string,
};

const ButtonContainer = glamorous.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  height: '8rem',
  marginTop: '-8rem',
});

const TsAndCs = glamorous.div({
  backgroundColor: '#2d2d2d',
  padding: 50,
});

const Title = glamorous.div(({ theme }) => ({
  textTransform: 'uppercase',
  fontSize: theme.fontSize.xlarge,
  fontWeight: theme.fontWeight.demiBold,
  textAlign: 'center',
  ...padding(theme.spacing.default, 0),
}));

const TermsTitle = glamorous.div(({ theme }) => ({
  ...padding(theme.spacing.default, 0),
  textAlign: 'center',
  fontWeight: theme.fontWeight.normal,
}));

const Text = glamorous.div(({ theme }) => ({
  ...padding(theme.spacing.default, 0),
  fontWeight: theme.fontWeight.normal,
  [theme.mediaQuery.desktopAndUp]: {
    ...padding(theme.spacing.default, 100),
  },
}));

const AppLinkDiv = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
});

const StyledAppLink = glamorous(AppLink)({
  padding: 20,
});

function HowToPlay({ appLinks, children, playLink }: Props) {
  return (
    <div>
      <ButtonContainer>
        <Button
          size="medium"
          kind="info"
          link="/how-to-play"
          style={{ marginRight: 12, width: 130, textAlign: 'center' }}
        >
          HOW TO PLAY
        </Button>
        <Button
          size="medium"
          kind="primary"
          link={playLink}
          style={{ width: 130, textAlign: 'center' }}
        >
          PLAY NOW
        </Button>
      </ButtonContainer>
      <TsAndCs>
        <Title>See you on the leaderboard</Title>
        <AppLinkDiv>
          {appLinks.map(item => <StyledAppLink href={item.href} imageUri={item.imageUri} />)}
        </AppLinkDiv>
        <TermsTitle>Special Terms and Conditions</TermsTitle>
        <Text>{children}</Text>
      </TsAndCs>
    </div>
  );
}

const connector = connect(
  state => ({
    appLinks: appLinksSelector(state),
  }),
  null,
);

export default connector(HowToPlay);
